import { render, staticRenderFns } from "./PublicRegionDescriptionContainer.vue?vue&type=template&id=7ae48112"
import script from "./PublicRegionDescriptionContainer.vue?vue&type=script&lang=js"
export * from "./PublicRegionDescriptionContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports